import { ValuableNode } from '../../models/ValuableNode'

export class SchemaAnyNode extends ValuableNode {}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Any': SchemaAnyNode
  }
}
